"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./_InputFormControl.scss");
var InputFormControl = function (_a) {
    var id = _a.id, initialValue = _a.initialValue;
    var _b = (0, react_1.useState)(initialValue), value = _b[0], setValue = _b[1];
    // label text
    var _c = (0, react_1.useState)(''), labelText = _c[0], setLabelText = _c[1];
    (0, react_1.useEffect)(function () {
        setLabelText(window.bes.spareparts.input1text);
    }, []);
    var handleChange = function (event) {
        setValue(event.target.value);
    };
    return (react_1.default.createElement("div", { className: "spr-input-formcontrol mb-3" },
        react_1.default.createElement("label", { htmlFor: id, className: "form-label" }, labelText),
        react_1.default.createElement("div", { className: "spr-input-formcontrol__input-wrapper" },
            react_1.default.createElement("input", { type: "text", className: "spr-input-formcontrol__input form-control", id: id, value: value, onChange: handleChange }),
            react_1.default.createElement("i", { className: "spr-input-formcontrol__input-icon" }))));
};
InputFormControl.displayName = "Input Form Control";
exports.default = InputFormControl;
